import { render, staticRenderFns } from "./ArchivedReports.vue?vue&type=template&id=e3730db6&scoped=true"
import script from "./ArchivedReports.vue?vue&type=script&lang=js"
export * from "./ArchivedReports.vue?vue&type=script&lang=js"
import style0 from "./ArchivedReports.vue?vue&type=style&index=0&id=e3730db6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e3730db6",
  null
  
)

export default component.exports